import { render, staticRenderFns } from "./OfferDistrict.vue?vue&type=template&id=3ec67680&scoped=true&"
import script from "./OfferDistrict.vue?vue&type=script&lang=js&"
export * from "./OfferDistrict.vue?vue&type=script&lang=js&"
import style0 from "./OfferDistrict.vue?vue&type=style&index=0&id=3ec67680&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ec67680",
  null
  
)

export default component.exports